"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormFieldEditorHeight = void 0;
const tslib_1 = require("tslib");
const core_api_1 = require("@ikegps/core-api");
const mobx_1 = require("mobx");
const icon_1 = require("../../../components/icon");
const icons_1 = require("../../../components/icon/icons");
const menu_1 = require("../../../components/menu/menu");
const menu_item_1 = require("../../../components/menu/menu.item");
const menu_item_style_1 = require("../../../components/menu/menu.item.style");
const theme_1 = require("../../../components/theme");
const i18n_1 = require("../../../i18n");
const mithril_1 = require("../../../mithril");
const services_1 = require("../../../services");
const form_palette_1 = require("../form.palette");
const form_field_editor_1 = require("./form.field.editor");
const CSS = {
    container: 'c-FdcHeight',
    title: 'c-FdcHeight__title',
    list: 'c-FdcHeight__list',
    menu: 'c-FdcHeight__menu',
    menuContainer: 'c-FdcHeight__menuContainer',
    option: 'c-FdcHeight__option',
    value: 'c-FdcHeight__value',
    ghost: 'c-FdcHeight__ghost',
    icon: {
        icon: 'c-FdcHeight__icon',
        label: 'c-FdcHeight__icon-label',
    },
    selected: 'c-FdcHeight__selected',
};
(0, theme_1.addStyles)({
    [CSS.container]: {
        width: '100%',
        display: 'flex',
        'flex-direction': 'column',
        '& .mdl-button': {
            height: 'fit-content',
            width: 'fit-content',
        },
    },
    [CSS.list]: {
        display: 'flex',
        width: '100%',
        'align-items': 'center',
    },
    [CSS.title]: {
        'font-weight': 'bold',
        'margin-bottom': theme_1.DefaultTheme.space(1),
        color: theme_1.DefaultTheme.font.color.supporting,
    },
    [CSS.option]: {
        width: '320px',
        'text-align': 'left',
        display: 'flex',
        'align-items': 'center',
    },
    [CSS.selected]: {
        width: '320px',
        'text-align': 'left',
        display: 'flex',
        'align-items': 'center',
    },
    [CSS.ghost]: {
        color: theme_1.DefaultTheme.font.color.supporting,
    },
    [CSS.value]: {
        width: '520px', // TODO this is from the input width
        'text-align': 'left',
    },
    [CSS.icon.icon]: {
        margin: '0 4px',
        'font-style': 'normal',
    },
    [CSS.icon.label]: {
        'border-radius': '50%',
        border: '1px solid ' + theme_1.DefaultTheme.background.grey,
        'background-color': theme_1.DefaultTheme.background.lightGrey,
        'font-weight': 'bold',
        'font-size': '12px',
        height: '16px',
        width: '16px',
        display: 'flex',
        'align-items': 'center',
        'justify-content': 'center',
        margin: '0 8px',
    },
    [CSS.menu]: {
        [`& .${menu_item_style_1.CSS.item}`]: {
            'padding-top': theme_1.DefaultTheme.space(1),
            'padding-bottom': theme_1.DefaultTheme.space(1),
            'line-height': theme_1.DefaultTheme.space(6),
        },
    },
    [CSS.menuContainer]: {
        display: 'flex',
        'flex-direction': 'column',
        position: 'relative',
    },
});
class FormFieldEditorHeight extends form_field_editor_1.FormFieldEditor {
    constructor(designer, field) {
        super(designer, field);
        this.list = this.getListOfTitleFields(this.field.parent);
        this.list.unshift({ displayName: 'Default', fieldId: null, fieldType: null });
        this.annotationMenu = new menu_1.MenuComponent({
            items: () => this.viewListItems(),
            className: CSS.container,
        });
        this.annotationLabel = this.list.find((l) => l.fieldId === this.field.annotationLabelFieldId) || this.list[0];
    }
    getListOfTitleFields(subform) {
        let list = [];
        if (subform.parent != null) {
            list.push(...this.getListOfTitleFields(subform.parent));
        }
        list.push(...subform.fields.map((x) => {
            let item = {
                displayName: x.displayName,
                fieldId: x.fieldId.split(':').pop(),
                fieldType: x.type,
                parentDisplayName: x.parent.parent ? x.parent.displayName : undefined,
            };
            if (x.fieldId === this.field.fieldId) {
                item.displayName = 'Self-Title (' + x.displayName + ')';
            }
            return item;
        }));
        return list;
    }
    getIcon(icon) {
        return icon
            ? icon_1.Icon.view(form_palette_1.FIELD_TYPE_DISPLAY[icon].icon, { className: CSS.icon.icon })
            : (0, mithril_1.m)('i', {
                className: CSS.icon.label + ' ' + CSS.icon.icon,
                title: (0, i18n_1.Translate)(i18n_1.T.FORM_OPTION_LABEL),
            }, 'L');
    }
    getLabelWithNode() {
        if (services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_MARKER_LABEL)) {
            return (0, mithril_1.m)('div', { className: CSS.container }, [
                (0, mithril_1.m)('div', { className: `${CSS.option} ${CSS.title}` }, 'Label With'),
                (0, mithril_1.m)('div', { className: CSS.menuContainer }, [
                    (0, mithril_1.m)('button', {
                        className: `mdl-button ${CSS.selected}`,
                        title: 'LABEL WITH',
                        onclick: this.annotationMenu.show,
                    }, [
                        this.getIcon(this.annotationLabel.fieldType),
                        this.annotationLabel.parentDisplayName
                            ? `${this.annotationLabel.parentDisplayName} > ${this.annotationLabel.displayName}`
                            : this.annotationLabel.displayName,
                        icon_1.Icon.view(icons_1.MaterialIcon.KEY_DOWN),
                    ]),
                    this.annotationMenu.view(),
                ]),
            ]);
        }
        return null;
    }
    //default view
    viewInfoRW() {
        const node = (0, mithril_1.m)('div', { className: CSS.list }, [this.getLabelWithNode()]);
        return node;
    }
    viewListItems() {
        const items = [];
        for (let i = 0; i < this.list.length; i++) {
            const option = this.list[i];
            items.push({
                view: menu_item_1.MenuItemComponent.view([
                    this.getIcon(option.fieldType),
                    option.parentDisplayName ? `${option.parentDisplayName} > ${option.displayName}` : option.displayName,
                ]),
                action: () => this.changeAnnotationField(option),
            });
        }
        return items;
    }
    changeAnnotationField(key) {
        this.setAnnotationLabelFieldId(key.fieldId);
        this.annotationLabel = key;
    }
}
exports.FormFieldEditorHeight = FormFieldEditorHeight;
tslib_1.__decorate([
    mobx_1.observable
], FormFieldEditorHeight.prototype, "annotationLabel", void 0);
tslib_1.__decorate([
    mobx_1.action.bound
], FormFieldEditorHeight.prototype, "changeAnnotationField", null);
//# sourceMappingURL=form.field.editor.height.js.map